<template>
  <div>
    <h1 class="page-header">{{ $t('gradingdefinition.grading') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="form-group m-b-15">
              <label class="required">{{
                $t('gradingdefinition.mainProgram')
              }}</label>
              <ts-search-select
                :options="mainPrograms"
                v-model="model.acp_id"
                :disabled="updating"
                @change="onChangeMainProgram()"
              >
              </ts-search-select>
              <div class="validate" v-if="errors.has('acp_id')">
                {{ errors.first('acp_id') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="required">{{
                $t('gradingdefinition.subProgram')
              }}</label>
              <ts-search-select
                :options="subProgramLists"
                v-model="model.acps_id"
                :disabled="updating"
              >
              </ts-search-select>
              <div class="validate" v-if="errors.has('acps_id')">
                {{ errors.first('acps_id') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="required">{{
                $t('gradingdefinition.definitionType')
              }}</label>
              <select class="form-control" v-model="model.definition_type">
                <option :value="null">{{ $t('select') }}</option>
                <option
                  v-for="(grading, index) in definitonTypes"
                  :key="index"
                  :value="grading"
                >
                  {{ grading }}
                </option>
              </select>
              <div class="invalid-feedback" v-if="errors.has('definiton_type')">
                {{ errors.first('definiton_type') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="required">{{
                $t('gradingdefinition.grade')
              }}</label>
              <input type="text" v-model="model.grade" class="form-control" :class="{ 'is-invalid': errors.has('grade') }"
                placeholder="Enter grading" />
              <div class="invalid-feedback" v-if="errors.has('grade')">
                {{ errors.first('grade') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="required">{{
                $t('gradingdefinition.meaningEN')
              }}</label>
              <input type="text" v-model="model.definition_name_en" class="form-control"
                :class="{ 'is-invalid': errors.has('definition_name_en') }" placeholder="Enter grading meaning en" />
              <div class="invalid-feedback" v-if="errors.has('definition_name_en')">
                {{ errors.first('definition_name_en') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label>{{ $t('gradingdefinition.meaningKH') }}</label>
              <input type="text" v-model="model.definition_name_kh" class="form-control kh-font"
                :class="{ 'is-invalid': errors.has('definition_name_kh') }" placeholder="Enter grading meaning KH" />
              <div class="invalid-feedback" v-if="errors.has('definition_name_kh')">
                {{ errors.first('definition_name_kh') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label>{{ $t('gradingdefinition.description') }}</label>
              <textarea rows="3" v-model="model.description" class="form-control kh-font"
                :class="{ 'is-invalid': errors.has('description') }" placeholder="Enter description"></textarea>
              <div class="invalid-feedback" v-if="errors.has('description')">
                {{ errors.first('description') }}
              </div>
            </div>
            <div class="text-right">
              <ts-button v-if="updating" class="mr-2" @click.prevent="cancel">
                {{ $t('cancel') }}
              </ts-button>
              <ts-button v-if="updating" class="btn-primary" :waiting="waiting" @click.prevent="update">
                {{ $t('update') }}
              </ts-button>
              <ts-button v-if="!updating" :waiting="waiting" class="btn-primary" @click.prevent="store">
                {{ $t('save') }}
              </ts-button>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-9 col-sm-12">
        <data-table :fetch="fetch" @fetched="fetch = false"></data-table>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import DataTable from './table'
export default {
  name: 'grading-definition-form',
  components: {
    DataTable
  },
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      fetch: false,
      updating: false,
      subPrograms: [],

      model: {
        grade_definition_id: '',
        acp_id: '',
        acps_id: '',
        grade: '',
        definition_type: null,
        definition_name_kh: '',
        description: '',
        definition_name_en: '',
        acps_id: ''
      },
      definitonTypes: ['Grading', 'Rating']
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('gradingDefinition', ['edit_data']),
    mainPrograms() {
      return this.$store.state.gradingDefinition.main_programs.map(el => ({
        value: el.acp_id,
        text: el.acp_name_foreign
      }))
    },
    subProgramLists () {
      return this.subPrograms
        .filter(s => s.acp_id == this.model.acp_id)
        .map(el => ({
          value: el.acps_id,
          text: el.acps_name_foreign
        }))
    }
  },
  methods: {
    async onChangeMainProgram () {
      this.model.acps_id = ''
      this.waiting = true
      await this.$store
        .dispatch('gradingDefinition/getSubProgram')
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .then(response => {
          this.subPrograms = response.data
        })
        .finally(() => {
          this.waiting = false
        })
    },
    store () {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('gradingDefinition/store', this.model)
        .then(response => {
          this.clearInput()
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    update() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('gradingDefinition/update', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
          this.cancel()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    cancel() {
      this.errors = new Errors()
      this.updating = false
      this.$store.commit('gradingDefinition/SET_EDIT_DATA', {})
      this.$router.push({ name: 'grading-definition' })
      this.clearInput()
    },
    clickBackURL() {
      this.$store.commit('gradingDefinition/SET_EDIT_DATA', {})
      this.clearInput()
      this.fetch = true
      this.updating = false
    },
    async setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        await this.onChangeMainProgram()
        this.errors = new Errors()
        this.model.grade_definition_id = this.edit_data.grade_definition_id
        this.model.acp_id = this.edit_data.acp_id
        this.model.acps_id = this.edit_data.acps_id
        this.model.grade = this.edit_data.grade
        this.model.definition_type = this.edit_data.definition_type
        this.model.description = this.edit_data.description
        this.model.definition_name_kh = this.edit_data.definition_name_kh
        this.model.definition_name_en = this.edit_data.definition_name_en
        this.updating = true
      }
    },
    clearInput() {
      this.model = {
        grade_definition_id: '',
        acp_id: '',
        acps_id: '',
        grade: '',
        definition_type: '',
        description: '',
        definition_name_kh: '',
        definition_name_en: '',
        acps_id: ''
      }
    }
  },
  watch: {
    edit_data: {
      handler() {
        this.setEditData()
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('gradingDefinition/RESET_STATE')
      this.clickBackURL()
    }
    next()
  }
}
</script>
